import React, { useEffect, useRef } from 'react'
import Login from './Components/Login/Login'
import App from './App';
import { Route, Routes, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import ResetPassword from './Components/Login/ResetPassword';
import CheckEmail from './Components/Login/CheckEmail';
import ChangePassword from './Components/Login/ChangePassword';
import ResetSuccessfull from './Components/Login/ResetSuccessfull';
import EmailVerification from './Components/Login/EmailVerification';
import UserTimeout from './Components/Login/UserTimeout';
import IntakeFormViewer from './Components/EHR/Intake Form/IntakeFormViewer';
import RestorePassword from './Components/Login/RestorePassword'
import TwoFactorAuth from './Components/Login/TwoFactorAuth';
import TwoFactorOTP from './Components/Login/TwoFactorOTP';
import BAAPassword from './Components/Login/BAAPassword';
import ViewStatement from './Components/Billing/Statements/StatementsDetails/Print Statements/ViewStatement';
import SystemIntakes from './Components/General/SystemIntakes/SystemIntakes';
import AddCard from './Components/CustomPayments/AddCard';
import ViewPaidReceipt from './Components/CustomPayments/ViewPaidReceipt';
import PatientSigntureForm from './Components/Patient/PatientSigntureForm/PatientSigntureForm';
import JoinTelehealth from './utils/TeleHealthJoinPage';
import ProtectedRoute from './utils/ProtectedRoute';
import ThemeProvider from './utils/ThemeProvider';
const MainRoute = () => {

  const RouteGuard = () => {
    const previousHash = useRef(window.location.hash);

    useEffect(() => {
      const handleHashChange = () => {
        const currentHash = window.location.hash;
        if (currentHash !== previousHash.current) {
          // Prevent navigation: reset the hash back to the previous one
          window.location.hash = previousHash.current;
        }
      };
      window.addEventListener("hashchange", handleHashChange);
      return () => {
        window.removeEventListener("hashchange", handleHashChange);
      };
    }, []);
    return null; // Component only for guarding the routes
  };

  return (
    <>
      <RouteGuard />
      <ThemeProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/pms" element={<App />} />
          </Route>
          <Route path="/forgotpassword" element={<ResetPassword />} />
          <Route path="/RestorePassword" element={<RestorePassword />} />
          <Route path="/TwoFactorAuth" element={<TwoFactorAuth />} />
          <Route path="/TwoFactorOTP" element={<TwoFactorOTP />} />



          <Route path="/checkemail" element={<CheckEmail />} />
          <Route path="/changepassword" element={<ChangePassword />} />
          <Route path="/changepassworBaa" element={<BAAPassword />} />
          <Route path="/resetsuccessfull" element={<ResetSuccessfull />} />
          <Route path="/emailverification" element={<EmailVerification />} />
          {/* <Route path="/usertimeout" element={<UserTimeout/>} /> */}
          <Route path="/intake" element={<IntakeFormViewer />} />
          <Route path="/sys-intake" element={<SystemIntakes />} />
          <Route path="/statementperview/:id" element={<ViewStatement />} />
          <Route path="/PatientPayment" element={<AddCard />} />
          <Route path="/Pay/:paymentId" element={<AddCard />} />
          <Route path="/ViewPaidReceipt/:paymentId" element={<ViewPaidReceipt />} />
          <Route path="/join-telehealth" element={<JoinTelehealth />} />

          <Route path="/patient-signature" element={<PatientSigntureForm />} />
        </Routes>
      </ThemeProvider>

    </>
  )
}
export default MainRoute